import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import zh from './locales/zh.json'
import zhhant from './locales/zh-Hant.json'
import ko from './locales/ko.json'

// 获取默认语言
const defaultLang = navigator.language || 'zh'

const i18n = createI18n({
    legacy: false, // 使用 composition API 模式
    locale: defaultLang,
    fallbackLocale: 'en',
    availableLocales: ['en', 'zh', 'zh-Hant', 'ko'],
    messages: {en, zh, 'zh-Hant': zhhant, ko}
})

export default i18n;